import { baseErrorHandler } from "@queries/baseErrorHandler";
import { showMessage } from "@queries/showMessage";
import { $api } from "@service/RequestService";
import { useMutation, useQueryClient } from "react-query";

import { queryKeys } from "../constants";

export function usePostCompanyConfigBookingDelay(delay: number) {
    const qc = useQueryClient();

    return useMutation(
        async () => {
            const res = await $api.post(`/v1/company-config/booking-delay?delay=${delay || 365}`);

            return res.data;
        },
        {
            onSuccess: data => {
                qc.invalidateQueries([queryKeys.COMPANY_CONFIG_BOOKING_DELAY]);
                showMessage(data.message, data.accept);
            },
            onError: baseErrorHandler
        }
    );
}